import {
    AllDayAnnualConsumptionSchema,
    PeakOffPeakAnnualConsumptionSchema,
} from "../schemas/annualConsumptionSchema"
import {
    type AllDayAnnualConsumption,
    type AnnualConsumptionWithSeason,
    type PeakOffPeakAnnualConsumption,
} from "../types/annualConsumption"

export function isAllDayAnnualConsumption(
    consumption: AnnualConsumptionWithSeason
): consumption is AllDayAnnualConsumption {
    return AllDayAnnualConsumptionSchema.safeParse(consumption).success
}

export function isPeakOffPeakAnnualConsumption(
    consumption: AnnualConsumptionWithSeason
): consumption is PeakOffPeakAnnualConsumption {
    return PeakOffPeakAnnualConsumptionSchema.safeParse(consumption).success
}
